import React from "react";
import { useParams } from "react-router-dom";
import RegistrationsListView from "../Registrations/RegistrationsListView";
import "../../../css/View/VariantRegistrations.css";

const VariantRegistrations = ({ registrations, variantGuid, activeSectionRef }) => {
  const { guid: tripGuid } = useParams();
  const filteredRegistrations = registrations.filter(r => r.variantGuid === variantGuid);

  return (
    <div className="trip-variant-section trip-variant-registrations">
      <RegistrationsListView registrations={filteredRegistrations} activeRef={activeSectionRef} registrationBasePath={`/trips/${tripGuid}/variants/${variantGuid}/registrations`} />
    </div>
  );
};

export default VariantRegistrations;
